import { getTheme, IconButton, IIconProps } from '@fluentui/react';
import * as React from 'react';

const { palette } = getTheme();
const copyIcon: IIconProps = { iconName: 'Copy' };

const styleCopyValue: React.CSSProperties = {
  position: 'absolute',
  zIndex: -1,
  opacity: 0
};

export interface CopyValueProps {
  text: string;
  buttonText: string;
  className?: string;
}

export class CopyValue extends React.PureComponent<CopyValueProps, Record<string, unknown>> {
  private inputRef;

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  render(): JSX.Element {
    return (
      <React.Fragment>
        <input
          ref={this.inputRef}
          type="text"
          style={styleCopyValue}
          value={this.props.text}
          size={this.props.text.length}
          readOnly
        />
        <IconButton
          iconProps={copyIcon}
          title={this.props.buttonText}
          ariaLabel={this.props.buttonText}
          onClick={(): void => this.copyTextToClipboard()}
          styles={{
            rootHovered: {
              backgroundColor: palette.neutralLighterAlt
            }
          }}
        />
      </React.Fragment>
    );
  }

  private copyTextToClipboard(): void {
    this.inputRef?.current?.select();
    document.execCommand('copy');
  }
}
